var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\tCleared "),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("Return ")])])}]

export { render, staticRenderFns }